export default function isMagicLink() {
    const currentUrl = window.location.href;  
    const urlParams = new URLSearchParams(currentUrl);
    return urlParams.has('sign');
}